import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import httpClient from "../../utils/httpClient";

const SOCIAL_LINKS = [
  { icon: "ti-brand-facebook", alt: "Facebook" },
  { icon: "ti-brand-instagram", alt: "Instagram" },
  { icon: "ti-brand-twitter", alt: "X" },
  { icon: "ti-brand-whatsapp", alt: "WhatsApp" },
  { icon: "ti-brand-youtube", alt: "YouTube" },
  { icon: "ti-brand-linkedin", alt: "LinkedIn" },
];

function WepriceLogo({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" aria-hidden="true">
      <polygon points="0,28 14,0 28,28" fill="#1a2e5a" />
      <polygon points="7,28 14,14 21,28" fill="#f5a623" />
    </svg>
  );
}

function Footer() {
  const navigate = useNavigate();
  const [emails, setEmails] = useState([]);
  const [socialLinks, setSocialLinks] = useState([]);

  const getSocialLinks = async () => {
    try {
      const response = await httpClient.get("admin/social-media");
      setSocialLinks(response.data.data?.socialMedia);
    } catch (error) {
      console.log(error);
    }
  };

  const getEmails = async () => {
    try {
      const response = await httpClient.get("admin/contact-us");
      setEmails(response.data.data?.contactUs);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getEmails();
    getSocialLinks();
  }, []);

  const activeSocial = socialLinks.filter(
    (item) =>
      item.isActive && SOCIAL_LINKS.some((social) => social.alt === item.name),
  );

  return (
    <footer className="wp-footer">
      <div className="wp-footer__inner">
        <div className="wp-footer__brand">
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <WepriceLogo />
            <span
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#fff",
                letterSpacing: "-0.5px",
              }}
            >
              We<span style={{ color: "#f5a623" }}>Price</span>
            </span>
          </div>
          <p>
            Connecting customers with trusted home service professionals across
            the UK. Transparent pricing, every time.
          </p>
          {activeSocial.length > 0 && (
            <ul className="wp-social">
              {activeSocial.map((item, index) => {
                const social = SOCIAL_LINKS.find((s) => s.alt === item.name);
                return (
                  <li key={index}>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="wp-social__icon"
                      aria-label={item.name}
                    >
                      <i className={`ti ${social?.icon}`} aria-hidden="true" />
                    </a>
                  </li>
                );
              })}
            </ul>
          )}
        </div>

        <div className="wp-footer__col">
          <h4>For customers</h4>
          <a
            className="footer-link"
            href="/#how-it-works"
            onClick={(e) => {
              e.preventDefault();
              navigate("/#how-it-works");
            }}
          >
            How it works
          </a>
          <a
            className="footer-link"
            href="/#services"
            onClick={(e) => {
              e.preventDefault();
              navigate("/#services");
            }}
          >
            Browse services
          </a>
          <a
            className="footer-link"
            href="/#testimonials"
            onClick={(e) => {
              e.preventDefault();
              navigate("/#testimonials");
            }}
          >
            Leave a review
          </a>
        </div>

        <div className="wp-footer__col">
          <h4>For providers</h4>
          <a
            className="footer-link"
            onClick={(e) => {
              e.preventDefault();
              navigate("/auth/register");
            }}
          >
            Join WePrice
          </a>
          <a
            className="footer-link"
            onClick={(e) => {
              e.preventDefault();
              navigate("/auth/login");
            }}
          >
            Provider sign in
          </a>
          <a
            className="footer-link"
            href="/#services"
            onClick={(e) => {
              e.preventDefault();
              navigate("/#services");
            }}
          >
            Browse services
          </a>
        </div>

        <div className="wp-footer__col">
          <h4>Company</h4>
          <a
            className="footer-link"
            onClick={(e) => {
              e.preventDefault();
              navigate("/content/terms-cond-prov");
            }}
          >
            Terms &amp; conditions
          </a>
          <a
            className="footer-link"
            onClick={(e) => {
              e.preventDefault();
              navigate("/content/privacy-policy-prov");
            }}
          >
            Privacy policy
          </a>
          {emails.map((item, index) => (
            <a key={index} href={`mailto:${item.email}`}>
              {item.email}
            </a>
          ))}
        </div>

        <div className="wp-footer__col">
          <h4>Contact &amp; Support</h4>
          {emails.length > 0 ? (
            emails.map((item, index) => (
              <a key={index} href={`mailto:${item.email}`}>
                {item.supportType}: {item.email}
              </a>
            ))
          ) : (
            <>
              <a href="mailto:support@weprice.com">support@weprice.com</a>
              <a href="mailto:providers@weprice.com">providers@weprice.com</a>
            </>
          )}
        </div>
      </div>

      <div className="wp-footer__bottom">
        <div className="wp-footer__bottom__inner">
          <p>&copy; 2025 WePrice Ltd. All rights reserved.</p>
          <p>Made in the UK</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
